import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage29.module.css";

export default function LaymanPage29() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF ARIES</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.om_block_main}>
                <div
                  className={`${styles.om_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/archetype_of_aries/aries_1img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/archetype_of_aries/aries_1img.webp`}/>
                  </div>
                  {/* className={styles.yellow_txt} */}
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>
                          Aries Unleashed: The Cosmic Fury and Wisdom of the
                          Warrior King
                        </h2>
                      </div>
                      <p>
                        Aries, a potent{" "} Cosmic Archetype deeply embedded{" "}
                        within the realms of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                        method and Archetypal Astrology, emerges as a Cardinal
                        Fire Influence, embodying the madness of war and the
                        purest essence of rage. Beyond its astrological
                        significance, Aries symbolizes the seedling of our most
                        individual self, crowned as king, with the power to
                        control and channel the primal forces of its own rage.
                      </p>
                      <p>
                        As a Cardinal Fire sign, Aries possesses an
                        uncontrollable and unpredictable nature, akin to the
                        untamed fires that blaze across the battlefield. Those{" "}
                        <span><i>"possessed by Aries"</i></span> find themselves at the
                        mercy of a cosmic force that drives them towards actions
                        that are both daring and assertive. In this archetype
                        lies the compassionate king, the ruler who answers to no
                        one and controls their rage at their leisure. Much like
                        the kings of ancient times, the compassionate ruler
                        recognizes the importance of maintaining dominion while
                        harnessing the{" "} vigor of statehood.
                      </p>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Symbolic Essence of OM:</h2>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/archetype_of_aries/aries_2img.webp"
                    /> */}
                    <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/archetype_of_aries/aries_2img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      {/* <div className={styles.layman_yellow_commn_header}>
                        <h2>The Vibration and Chanting:</h2>
                      </div> */}
                      <p>
                        In the historical context of the{" "}
                          Greek city-states, Aries embodies the dual nature of a tyrant and hero.
                        Aries is the greatest warrior and leader of the city,
                        revered and venerated. The Spartans, the epitome of
                        Greek warrior culture, drew inspiration from the violent
                        warrior tendencies of Aries, conditioning them through
                        discipline and an ascetic way of life. Aries
                        encapsulates a hidden madness and bloodthirsty energy,
                        dormant but ready to be unleashed when facing formidable
                        enemies, be they actual adversaries or the relentless
                        foes that emerge from within our own minds.
                      </p>

                      <p>
                        To work under the influence of Aries is to set one's
                        house in order, to rule one's domain with unyielding
                        authority, and to fight valiantly in defense until
                        victory is achieved. Aries draws on challenge and
                        refinement, much like the young Spartans entering the
                        field of battle, seeking to gain valuable possessions
                        and rid oneself of useless burdens.{" "}
                          The Emperor of Thoth invokes the impulse to create or
                          destroy, to rule with the wisdom of kingship,
                          embodying the very essence of Aries.
                      </p>
                      <p>
                        In conclusion,{" "}
                          Aries is not merely a symbol{" "}
                        within the astrological tapestry; it is a cosmic force
                        that calls upon individuals to embrace their inner
                        warrior king. It is a call to confront challenges
                        head-on, refine one's character, and rule with wisdom
                        and authority. As{" "} seekers navigate the cosmic forces of Aries,{" "}
                        they embark on a journey of self-discovery and conquest,
                        drawing on the primal energies that lie within, ready to
                        be harnessed in the pursuit of victory and kingship.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/archetype_of_aries/aries_3img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/archetype_of_aries/aries_3img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <p>
                        <b>Cosmic Archetype:</b> Aries is a potent Cosmic
                        Archetype within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                        method and{" "}
                          Archetypal Astrology,{" "}
                        representing a cardinal fire influence.
                      </p>

                      <p>
                        <b> Cardinal Fire Influence:</b> Aries is characterized
                        by its cardinal fire influence, embodying the primal
                        forces of assertiveness and daring action.
                      </p>
                      <p>
                        <b>Madness of War:</b>{" "}
                          Aries symbolizes{" "}
                        the madness of war, portraying an untamed and
                        unpredictable nature reminiscent of the fires that blaze
                        on the battlefield.
                      </p>
                      <p>
                        <b>Purest Experience of Rage:</b> Individuals{" "}
                        <span><i>"possessed by Aries"</i></span> may experience the
                        purest essence of rage, tapping into a cosmic force that
                        drives them toward assertive and bold actions.
                      </p>

                      <p>
                        <b>Individual Self as King:</b> Aries represents the
                        seedling of the most individual self, crowned as a king,
                        with the power to control and channel primal forces.
                      </p>

                      <p>
                        <b>Compassionate King:</b> Within the{" "}
                          Aries archetype,{" "}
                        there is the compassionate king who answers to no one
                        and can control their rage at will.
                      </p>
                      <p>
                        <b>Tyrant and Hero:</b> In historical contexts,{" "}
                          Aries embodies{" "}
                        the dual nature of a tyrant and hero, being both the
                        greatest warrior and leader of the city-states.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.om_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.orphic_egg_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/archetype_of_aries/aries_4img.webp"
                    /> */}
                     <img className={styles.orphic_egg_img1} src={`${process.env.cloud_url}Layman-Symbolism/archetype_of_aries/aries_4img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Vigor of Statehood:</b> Aries, much like the
                        Spartans, draws on the vigor of statehood, recognizing
                        the importance of maintaining dominion and authority.
                      </p>

                      <p>
                        <b>Conditioning through Discipline:</b> The violent
                        warrior tendencies of Aries can be conditioned through
                        discipline and an ascetic life, much like the Spartan
                        way of life.
                      </p>
                      <p>
                        <b>Hidden Madness and Bloodthirsty Energy:</b> Aries
                        hides a dormant madness and{" "}
                          bloodthirsty energy,{" "}
                        ready to be unleashed when facing formidable enemies,
                        whether external or internal.
                      </p>

                      <p>
                        <b>Set Your House in Order:</b> Working under the
                        influence of Aries is akin to setting one's house in
                        order, ruling one's domain with authority and defending
                        it fiercely.
                      </p>

                      <p>
                        <b>Challenge and Refinement:</b> Aries draws on
                        challenge and refinement, encouraging individuals to
                        seek conquest, gain valuable possessions, and rid
                        themselves of useless burdens.
                      </p>

                      <p>
                        <b>Emperor of Thoth:</b>{" "}
                          The Emperor of Thoth{" "}
                        archetype invokes the impulse to create or destroy,
                        ruling with the wisdom of kingship, embodying the
                        essence of Aries.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* =========================================greensec---------------------------------------------               */}

            <div className={styles.green_sec_cmn_main_wrp}>
              <div className={styles.common_width}>
                <Link href="/rota-the-wheel">
                  <div className={styles.green_sec_cmn_sub_wrp}>
                    <h1>
                      The Astrological Tarot association for Aries is <br /> The
                      Emperor. See our alchemical ROTA here
                    </h1>
                  </div>
                </Link>
              </div>
            </div>
            {/* ---------------------------------------------------greensec_end=================================== */}

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_aries/layman_page29_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_aries/layman_page29_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_aries/layman_page29_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_aries/layman_page29_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_aries/layman_page29_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
